import React from "react";
import { T } from "react-translator-component";
import { Modal, Box, Typography, Button } from "@mui/material";
import SubmitButton from "./SubmitButton";
import { colors } from "../common/colors";

// Define the props interface
interface TwoButtonModalProps {
  open: boolean;
  showButton?: boolean;
  message: string;
  messageDetail?: string;
  onClose: () => void;
  onContinue: () => Promise<boolean>;
  noText?:string;
  yesText?:string;
  btnStyle?: any;
}

const TwoButtonModal: React.FC<TwoButtonModalProps> = ({
  open,
  onClose,
  onContinue,
  message,
  messageDetail = '',
  noText,
  yesText,
  btnStyle,
}) => {

  const defaultBtnStyle = {
    cursor: "pointer",
    width: "50%",
    textAlign: "center",
    border: "0.5px solid gray",
    borderRight: "none",
    borderRadius: 0,
    padding: "10px",
    color: colors.farm_blue200,
    fontWeight: "bold"
  }

  const buttonStyle = () => {
    let style = btnStyle ?? defaultBtnStyle
    return {...style, color: colors.farm_blue200}
  }

  const style = {
    textBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "85%",
      maxWidth: 300,
      bgcolor: "background.paper",
      boxShadow: 24,
      borderRadius: 2,
      transition: "opacity 0.3s ease-in-out",
      outline: 'none',
    },
    message: {
      mb: messageDetail ? 0 : 2,
      textAlign: "center",
      padding: "22px 17px",
      fontWeight: messageDetail ? "bold" : "normal"
    },
    messageDetail: {
      mb: 3,
      padding: "0 20px"
    },
    displayBlock: {
      display: 'block'
    },
    buttonBox: {
      display: "flex",
      justifyContent: "space-between"
    },
    noButton: {
      ...buttonStyle(),
      borderLeft: "none"
    }
  }

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={style.textBox}
        >
          <Typography
            variant="body1"
            sx={style.message}
          >
            {message.split("\n").map((text: string, index: number) => <span style={style.displayBlock} key={index}>{text}</span>)}
          </Typography>

          {messageDetail && (
            <Typography
              variant="body1"
              sx={style.messageDetail}
            >
              {messageDetail.split("\n").map((text: string, index: number) => <span style={style.displayBlock} key={index}>{text}</span>)}
            </Typography>
          )}

          <Box sx={style.buttonBox}>
            <Button
              sx={style.noButton}
              onClick={onClose}
            >
              {noText??`${T('close')}`}
            </Button>
            <SubmitButton
              sx={buttonStyle()}
              size={"large"}
              validate={async () => true}
              onSubmit={onContinue}
            >
              {yesText??`${T('yes')}`}
            </SubmitButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default TwoButtonModal;